export enum CohortDefinitionStatus {
  DRAFT = 'DRAFT',
  PROCESSING = 'PROCESSING',
  PROCESSED = 'PROCESSED',
  ERROR = 'ERROR',
  FINAL = 'FINAL',
  UNSAVED = 'UNSAVED',
}

export enum SimpleEventFilterType {
  CONCEPT = 'CONCEPT',
  NUMERIC = 'NUMERIC',
  RELATED_ENTITY = 'RELATED_ENTITY',
  UNIQUENESS = 'UNIQUENESS',
}
